import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
// import { useDispatch } from "react-redux";
import { Form, Button, Card, Space } from "antd";
import { toast } from "react-toastify";
import FormFields from "./FormFields";
import { useDispatch, useSelector } from "react-redux";
import { addRegion } from "../../../redux/slices/regions/regionsThunk";
import { getGovernments } from "../../../redux/slices/governments/governmentsThunk";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const AddRegionPage = () => {
  const region_data = useSelector((state) => state.regions.region);
  const region_loading = useSelector((state) => state.regions.loading);
  const region_error = useSelector((state) => state.regions.error);

  const dispatch = useDispatch()
  const [form] = Form.useForm();
  const history = useHistory();

  const onFinish = (values) => {
    const formattedValues = {
      name: values.name,
      government: values.government,
    };
    dispatch(addRegion(formattedValues)).then(
      (res) => {
        if (res.meta.requestStatus === "fulfilled") {
          toast.success("Région ajoutée avec succès");
          history.push("/régions");
        } else {
          toast.error("Erreur lors de l'ajout de la région");
        }
      }
    );
  };

  useEffect(() => {    
    dispatch(getGovernments({ page: 1, limit: 30 }))
  }, [region_data, region_error, dispatch, form]);

  const onReset = () => {
    form.resetFields();
  };

  const navigateTo = (path) => {
    history.push(path);
  };

  return (
    <div>
      <Card
        bordered
        className="criclebox tablespace mb-24"
        title="Ajouter une région"
      />
      <Card bordered={false}>
        <Form
          {...layout}
          form={form}
          name="control-hooks"
          onFinish={onFinish}
        >
          <FormFields />
          <Form.Item {...tailLayout}>
            <Space size="small">
              <Button type="primary" htmlType="submit" loading={region_loading}>
                Enregistrer
              </Button>
              <Button htmlType="button" onClick={onReset}>
                Reset
              </Button>
              <Button type="link" htmlType="button" onClick={() => navigateTo("/régions")}>
                Annuler
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default AddRegionPage;
